// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__2lUnr","main_content":"style_main_content__VWs8s","mt_0":"style_mt_0__3WWzN","wapper_page_mobile":"style_wapper_page_mobile__2vaBW","intro":"style_intro__3oCOA"};